import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, switchMap } from 'rxjs';
import { TherapistServiceNew } from '../services/therapist-new.service';
import { AuthService } from '@auth0/auth0-angular';
import {
  CHANGE_INITIAL_PASSWORD,
  LOGIN_PATH,
} from '../../../../apps/values/path';

export const HasChangedInitialPasswordTherapist: CanActivateFn = (
  route,
  state
) => {
  const ROUTER = inject(Router);
  const auth0Service = inject(AuthService);
  const therapistService = inject(TherapistServiceNew);

  return auth0Service.user$.pipe(
    switchMap((user) => {
      if (!user?.sub) {
        ROUTER.navigate([`/${LOGIN_PATH}`]);
        return [false];
      }

      return therapistService.getTherapistProfile(user.sub).pipe(
        map((therapistProfile) => {
          if (
            therapistProfile &&
            therapistProfile.has_changed_initial_password === false
          ) {
            ROUTER.navigate([`/${CHANGE_INITIAL_PASSWORD}`]);
            return false;
          }
          return true;
        })
      );
    })
  );
};
